import { runtimeConfig } from '@/config/runtime-config'
import { createApiClient } from '@/lib/api/http-client'
import { readStoredPortalAccount } from '@/lib/auth/session-storage'
import { getStoredToken, type PortalKind } from '@/lib/auth/token-storage'

export interface PasswordResetPayload {
  currentPassword: string
  newPassword: string
}

/**
 * 重设当前门户密码。
 * 用户端是“当前用户改密”接口；后台管理员改自己的密码需要拼接当前 admin id。
 */
export function resetPortalPassword(portal: PortalKind, values: PasswordResetPayload) {
  const passwordResetClient = createApiClient({
    baseUrl: runtimeConfig.apiBaseUrl,
    getToken: () => getStoredToken(portal),
    portal,
  })
  let path = '/app/user/password'

  if (portal === 'admin') {
    // 后台改密 endpoint 复用管理员管理接口，因此必须从登录账号快照拿当前 admin id。
    const adminId = readStoredPortalAccount('admin').id
    if (!adminId) {
      throw new Error('Missing admin account id')
    }

    path = `/admin/settings/admins/${encodeURIComponent(adminId)}/password`
  }

  return passwordResetClient.request<{ code: 'success'; message?: string }>(path, {
    body: JSON.stringify({
      current_password: values.currentPassword,
      new_password: values.newPassword,
    }),
    method: 'PUT',
  })
}
